var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNftCardFlip = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0948 0.674376C15.5515 -0.224792 13.65 -0.224792 12.1066 0.674376L2.69525 6.15757C1.15191 7.05674 0.201172 8.71847 0.201172 10.5168V21.4832C0.201172 23.2815 1.15191 24.9433 2.69525 25.8424L12.1066 31.3256C13.65 32.2248 15.5515 32.2248 17.0948 31.3256L26.5062 25.8424C28.0495 24.9433 29.0003 23.2815 29.0003 21.4832V10.5168C29.0003 8.71847 28.0495 7.05674 26.5062 6.15757L17.0948 0.674376Z",
    fill: "#0E2659"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0948 0.674376C15.5515 -0.224792 13.65 -0.224792 12.1066 0.674376L2.69525 6.15757C1.15191 7.05674 0.201172 8.71847 0.201172 10.5168V21.4832C0.201172 23.2815 1.15191 24.9433 2.69525 25.8424L12.1066 31.3256C13.65 32.2248 15.5515 32.2248 17.0948 31.3256L26.5062 25.8424C28.0495 24.9433 29.0003 23.2815 29.0003 21.4832V10.5168C29.0003 8.71847 28.0495 7.05674 26.5062 6.15757L17.0948 0.674376Z",
    fill: "url(#paint0_radial_9068_403373)",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0098 8.77311L15.5984 3.28992C14.981 2.93025 14.2204 2.93025 13.6031 3.28992L4.19169 8.77311C3.57436 9.13278 3.19406 9.79747 3.19406 10.5168V21.4832C3.19406 22.2025 3.57436 22.8672 4.19169 23.2269L13.6031 28.7101C14.2204 29.0698 14.981 29.0698 15.5984 28.7101L25.0098 23.2269C25.6271 22.8672 26.0074 22.2025 26.0074 21.4832V10.5168C26.0074 9.79747 25.6271 9.13278 25.0098 8.77311ZM17.0948 0.674376C15.5515 -0.224792 13.65 -0.224792 12.1066 0.674376L2.69525 6.15757C1.15191 7.05674 0.201172 8.71847 0.201172 10.5168V21.4832C0.201172 23.2815 1.15191 24.9433 2.69525 25.8424L12.1066 31.3256C13.65 32.2248 15.5515 32.2248 17.0948 31.3256L26.5062 25.8424C28.0495 24.9433 29.0003 23.2815 29.0003 21.4832V10.5168C29.0003 8.71847 28.0495 7.05674 26.5062 6.15757L17.0948 0.674376Z",
    fill: "url(#paint1_linear_9068_403373)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6723 16.8313C18.6133 16.8919 18.5485 16.9432 18.481 16.9878L13.9332 21.6595C13.7124 21.8866 13.4228 22 13.1333 22C12.8438 22 12.5544 21.8866 12.3334 21.6595C11.8915 21.2056 11.8915 20.4695 12.3334 20.0157L16.2522 15.9895L12.3531 11.9842C11.9112 11.53 11.9112 10.7942 12.3531 10.3404C12.795 9.88645 13.5114 9.8867 13.9533 10.3401L18.4809 14.991C18.5484 15.0355 18.6132 15.0867 18.672 15.1475C18.8979 15.3795 19.0069 15.6851 19.0018 15.9895C19.0071 16.2936 18.8984 16.5991 18.6723 16.8313Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9068_403373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6007 16) rotate(90) scale(16 14.3996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4987FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4987FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9068_403373",
    x1: 14.6007,
    y1: 0,
    x2: 14.6007,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005CE8"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNftCardFlip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nft-card-flip.1fd6ecf4d13a4021559db622e393a21e.svg";